module.exports = __webpack_public_path__ + "media/img/home/our-work/photo-3-2587db357069b1a19ac8ecf1bf52977a.webp";